export const FRIEND_CARD_BG = 'https://imgheybox.max-c.com/oa/2023/02/23/e9953ae50ed18957691a57cda79444c4.png';